/**
 * Checks if region is specified in a location
 * This fn has been mostly used to check if our saved cookies location is a region
 *
 * @param latitude
 * @param longitude
 * @returns
 */
export const isRegionSpecified = (
  latitude?: string | number | null,
  longitude?: string | number | null
) => {
  const latNotNumber = !!(typeof latitude === 'number' && isNaN(latitude))
  const longNotNumber = !!(typeof longitude === 'number' && isNaN(longitude))

  return (
    !!(latitude === null || latitude === undefined || latNotNumber) &&
    !!(longitude === null || longitude === undefined || longNotNumber)
  )
}
